<template>
  <BreadcrumbSelect
    v-if="hasProjectNavigation"
    id="project-select"
    v-model="currentProject"
    :options="projectList"
    :placeholder="'Project'"
    :displayTag="'name'"
  />
  <SVGIcon
    v-if="hasDatasetNavigation"
    :iconName="'arrow_right'"
    :width="'32px'"
    :height="'32px'"
  />
  <BreadcrumbSelect
    v-if="hasDatasetNavigation"
    id="dataset-select"
    v-model="currentDataset"
    :options="datasets"
    :placeholder="'Dataset'"
    :displayTag="'name'"
  />
</template>

<script setup>
import {
  computed, watch, nextTick,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import BreadcrumbSelect from '@/components/BreadcrumbSelect.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import { useStore } from 'vuex';
import { useProjectsDatasetsStore } from '@/stores/useProjectsDatasetsStore';
import { storeToRefs } from 'pinia';

const props = defineProps({
  hasProjectNavigation: {
    type: Boolean,
    default: true,
  },
  hasDatasetNavigation: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['project-changed', 'dataset-changed']);

const store = useStore();
const route = useRoute();
const router = useRouter();

const projectsDatasetsStore = useProjectsDatasetsStore();
const { loadInitialData } = useProjectsDatasetsStore();
const { isLoadingInitialData } = storeToRefs(projectsDatasetsStore);
const {
  refreshDatasetList,
} = projectsDatasetsStore;
const {
  projectList,
  datasets,
  currentProject,
  currentDataset,
} = storeToRefs(projectsDatasetsStore);

const currentProjectId = computed(() => store.state.projects.currentProject?.id || null);
const currentDatasetId = computed(() => store.state.datasets.currentDataset?.id || null);

async function refreshDatasetListAndCurrentDataset(project_id) {
  await refreshDatasetList(project_id);
  await nextTick();
  if (props.hasDatasetNavigation && !currentDataset.value && datasets.value.length) {
    currentDataset.value = datasets.value[0];
  }
}

watch(currentProjectId, async (newProjectId) => {
  emit('project-changed', newProjectId);
  store.commit('datasets/setCurrentDataset', null);
  refreshDatasetListAndCurrentDataset(newProjectId);
});

watch(currentDatasetId, async (newDatasetId) => {
  await router.replace({
    name: route.name,
    query: {
      ...route.query,
      dataset: newDatasetId,
      project: currentProjectId.value,
    },
  });
  emit('dataset-changed', newDatasetId);
});
</script>

<style lang="scss" scoped>

</style>
